import { useState } from "react";

const navLinks = [
  { label: "话题墙", href: "#topics" },
  { label: "焦点事件", href: "#focus" },
  { label: "学校回应", href: "#responses" },
  { label: "班级群聊", href: "#chat" },
  { label: "处分结果", href: "#results" },
  { label: "讨论区", href: "#discussion" },
];

export default function Masthead() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-foreground-900/10 bg-background-50/90 backdrop-blur-md">
      <div className="w-full border-b border-foreground-900/10">
        <div className="mx-auto flex h-9 max-w-[1400px] items-center justify-between px-4 text-[11px] tracking-[0.2em] text-foreground-500 md:px-8">
          <span className="whitespace-nowrap">校园事件观察 · 第 2026 期</span>
          <span className="hidden sm:block">2026年9月11日 星期五</span>
          <span className="hidden md:block text-accent-600">以公开信息还原事件脉络</span>
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4 md:h-20">
          <a href="#top" className="flex cursor-pointer items-baseline gap-2 md:gap-3">
            <h1 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              黑料学生
            </h1>
            <span className="hidden text-[10px] tracking-[0.34em] text-accent-600 sm:inline md:text-[11px]">
              CAMPUS FILE
            </span>
          </a>

          <nav className="hidden items-center gap-6 text-sm text-foreground-700 lg:flex xl:gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="relative cursor-pointer whitespace-nowrap transition-colors after:absolute after:-bottom-1 after:left-0 after:h-px after:w-0 after:bg-accent-500 after:transition-all after:duration-300 hover:text-foreground-950 hover:after:w-full"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="#discussion"
              className="hidden cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-add-line" />
              </span>
              提供线索
            </a>
            <button
              type="button"
              aria-label="打开导航菜单"
              onClick={() => setOpen((value) => !value)}
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-foreground-900/15 text-foreground-800 lg:hidden"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </div>

      {open ? (
        <nav className="border-t border-foreground-900/10 bg-background-50 lg:hidden">
          <div className="mx-auto flex max-w-[1400px] flex-col px-4 py-2 md:px-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="flex cursor-pointer items-center justify-between border-b border-foreground-900/5 py-3 text-sm text-foreground-700 last:border-0"
              >
                {link.label}
                <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
                  <i className="ri-arrow-right-s-line" />
                </span>
              </a>
            ))}
          </div>
        </nav>
      ) : null}
    </header>
  );
}